import { translate } from '../../helpers/translate.helper';
import { LabelText } from '../../LabelText/LabelText';
import { Th } from '../../Table/Th';
import { Tr } from '../../Table/Tr';
import { PriceHeading } from '../common/PriceHeading';
import { useProductTableConfig } from '../hooks/useProductTableConfig';

export const TableHeaderRow = () => {
    const { showPrices, editable, editPrices } = useProductTableConfig();

    return (
        <Tr>
            <Th width="25%">
                <LabelText>{translate('order.product')}</LabelText>
            </Th>
            <Th width="10%">
                <LabelText>{translate('order.productgroup')}</LabelText>
            </Th>
            <Th width="15%">
                <LabelText>{translate('order.packtype')}</LabelText>
            </Th>
            <Th width="7%">
                <LabelText>{translate('order.unitsize')}</LabelText>
            </Th>
            <Th width="7%">
                <LabelText>{translate('order.quantity')}</LabelText>
            </Th>
            <Th width="5%">
                <LabelText display="block" textAlign="right">
                    {translate('order.volume')}
                </LabelText>
            </Th>
            <Th width="7%">
                <LabelText>{translate('order.unit')}</LabelText>
            </Th>

            {showPrices ? (
                <>
                    <Th width="10%">
                        <LabelText display="block" textAlign={editPrices ? 'left' : 'right'}>
                            <PriceHeading align={editPrices ? 'left' : 'right'} />
                        </LabelText>
                    </Th>
                    <Th width="10%">
                        <LabelText display="block" textAlign="right">
                            {translate('order.total')}
                        </LabelText>
                    </Th>
                </>
            ) : null}

            {/*@ts-ignore*/}
            {editable ? <Th width="3%" /> : null}
        </Tr>
    );
};
